import { AfterViewInit, Component, OnInit , OnDestroy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/api.service';
import { AppComponent } from 'src/app/app.component';
import { UtilitiesService } from 'src/app/utilities.service';
import { SharedInfoService } from '../../sharedInfo.service';
declare var $: any;
import { Meta, Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements AfterViewInit , OnInit, OnDestroy{

  public storeInfo: any;
  mainContent: any;
  page: any;
  show: boolean = false;
  enquiryForm!: FormGroup;
  description: string = "";

  constructor(private sharedInfoService: SharedInfoService, private sanitizer: DomSanitizer,
    private api: ApiService,
    private app: AppComponent,
    public util: UtilitiesService,
    private meta: Meta,
    private title : Title,
    private fb : FormBuilder,
    private modalService : NgbModal,
    private router: Router) {
    this.sharedInfoService.storeList.subscribe(data => {
      this.sharedInfoService.currentPage.subscribe(page => {
        this.page = page;
        if (this.page == 1) {
          this.storeInfo = data;
        } else {
          this.storeInfo = [...this.storeInfo, ...data];
        }
      });

    });
  }
 ngOnInit(){
   this.api.heaerAndFooter.next(true);
  setTimeout(()=>{
    if(this.app.leadForm){
      this.show = true;
      this.app.leadForm = false;
    }
  }, 4000)

  
  let emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
  this.enquiryForm = this.fb.group({
    name: ['', [Validators.required,Validators.minLength(2), Validators.pattern('^[^<>!1234567890]*$')]],
    email: ['', [Validators.pattern(emailPattern)]],
    mobileNo: ['', [Validators.required, Validators.pattern("[0-9]*"), Validators.minLength(10)]],
    pincode: ['', [Validators.required, Validators.pattern("[0-9]*"), Validators.minLength(6)]],
    query: [''],
    sourceName: ['STORELOCATORHOME']
  });
 }


   
  get myForm() {
    return this.enquiryForm.controls;
  }
 
  ngAfterViewInit(): void {
    this.app.locationOn.subscribe((val) => {
      let tenant = this.app.tenantId;
      let lat = this.app.latitude;
      let lang = this.app.longitude;
      let distance = this.app.distance;
      let record = this.app.record;
      let page = 0;
      let type = this.app.searchType;
      this.app.locationOffOn = val;
      if (this.app.locationOffOn === true) {
        this.util._loading.next(true)
        this.api.getStoreDetails(tenant, lat, lang, distance, record, type, page).subscribe((data) => {
          this.util._loading.next(false)
          this.storeInfo = data;
          this.sharedInfoService.page.next(1);
        }, (err) => {
          this.util._loading.next(false)
          console.log(err)
        });
      }
    });

    this.meta.updateTag(  
      { name: 'description', content: 'Dell India’s official store locator. Here are Dell Exclusive Stores and Dell Reseller Stores. Also, look for Dell Stores near you & get automated directions. Contact the store, Enquire prices, etc.' },  
      'name=description'  
    ) 
    this.meta.updateTag({
       name: 'keywords', content: 'Store Locator for Dell' 
    }, 'name=keywords')

    this.title.setTitle("Dell India's official store locator - Dell Exclusive Stores") 
  }

  close(){
    console.log(this.show);
    
    this.show = false;
    this.app.leadForm = false;
  }
  maxLengthTen(eve: any) {
    eve.target.value = eve.target.value.replace(/[^0-9]/g, "");
    eve.target.value = eve.target.value.substring(0, 10)
    return false
  }

  maxLengthSix(eve: any) {
    eve.target.value = eve.target.value.replace(/[^0-9]/g, "");
    eve.target.value = eve.target.value.substring(0, 6)
    return false
  }

  submitted = false;
  submitText ="Submit";
  onSubmit(event :any,content : any){
    this.submitted = true
  let lead =  {
      "email":this.enquiryForm.value.email,
      "mobileNo":this.enquiryForm.value.mobileNo,
      "name":this.enquiryForm.value.name,
      "pincode":this.enquiryForm.value.pincode,
      "query":this.enquiryForm.value.query,
      "sourceName":this.enquiryForm.value.sourceName
    }
    this.app.loadPixelScript(this.enquiryForm.value.pincode,"");
    let sourceName = this.enquiryForm.value.sourceName
     if(this.enquiryForm.valid){
      console.log(this.enquiryForm);
      this.submitText = "Loading..."
      this.api.storeLocatorPageLead(lead, sourceName, this.app.tenantId).subscribe(data =>{
        this.submitText = "Submit";
        this.close();
        if (data.status == "SUCCESS") {
          this.submitted = false;
          this.router. navigate(['thankyou'], {
            queryParams: { username:  lead.name, thankYouPage  : 1 },
            queryParamsHandling: 'merge',
          }); 
          // this.description = data.desc;
          // this.modalService.open(content, { windowClass: "modalCls" })
          // this.enquiryForm.reset();
        } else {
          this.description = data.desc;
          this.modalService.open(content, { windowClass: "modalCls" })
        }
      },
      err =>{
        this.submitText = "Submit";
        this.submitted = false;
        console.log(err);
        
      })
     }
  }

  ngOnDestroy(): void {
    this.app.leadForm = false;
  }
}
